import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteTaxRate($companyId: ID!, $id: ID!) {
    deleteTaxRate(companyId: $companyId, id: $id) {
      taxRate {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
